<template>
  <div class="confirm-delete">
    <div class="loading-animation" v-show="isDeleting && !isCompleted"></div>
    <div class="complete-animation" v-show="isCompleted"></div>
    <TitleBar :text="$t('ConfirmDelete.topic')" :enableIconButton="false" @clickCloseButton="clickCloseButton" v-show="!isDeleting && !isCompleted" />
    <div class="body" v-show="!isDeleting && !isCompleted">
      <div class="text">{{ $t('ConfirmDelete.message') }}</div>
      <SearchResultCard class="promptpai-card"
        :categoryIconPath="promptpaiDescription.iconfilename"
        :categoryIconHdPath="promptpaiDescription.iconfilename_hd"
        :code="promptpaiDescription.promptpai_id"
        :nameTh="promptpaiDescription.promptpai_name_th"
        :nameEn="promptpaiDescription.promptpai_name_en"
        :addressTh="promptpaiDescription.promptpai_address_th"
        :addressEn="promptpaiDescription.promptpai_address_en"
        :isFav="'marked_favorite' in promptpaiDescription ? promptpaiDescription.marked_favorite : false"
        :isHidePromptpaiIcon="true"
        @clickSearchResultCard="() => {}"
        @clickPromptpaiIcon="() => {}" />
      <div class="button-container">
        <button @click="clickDeleteButton">{{ $t('ConfirmDelete.ok') }}</button>
        <button class="outline" @click="clickCloseButton">{{ $t('ConfirmDelete.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import SearchResultCard from '@/components/SearchResultCard.vue'

export default {
  name: 'ConfirmDelete',
  components: {
    TitleBar,
    SearchResultCard
  },
  props: {
    promptpaiDescription: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      isDeleting: false,
      isCompleted: false
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    clickDeleteButton () {
      var self = this
      if (self.isDeleting) {
        return
      }
      self.isDeleting = true
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.deletePromptpai(
        self.promptpaiDescription.promptpai_id,
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.updateRecentList()
            self.updateFavoriteList()
            self.isDeleting = false
            self.isCompleted = true
            window.gtag('event', 'delete', {'event_category': 'engagement', 'event_label': `delete_place_${result.data.promptpai_id}`})
            setTimeout(() => {
              self.isCompleted = false
              self.$router.replace('/map/myplace/@13.764955,100.538317,12,1,0?my_place_tab=Favorite')
            }, 1000)
          } else if (result.status.code === 401) {
            self.isDeleting = false
            self.loginAgain()
          } else if (result.status.code === 403) {
            self.isDeleting = false
          } else {
            self.isDeleting = false
          }
        }
      )
    },
    updateRecentList () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.setRecentPage(1)
      self.pp.getRecentPlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        self.itemsPerPage,
        'all',
        self.itemsPerPage * (self.recentPage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.setRecentList(result.data)
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    updateFavoriteList () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.setFavoritePage(1)
      self.pp.getFavoritePlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.itemsPerPage,
        self.itemsPerPage * (self.favoritePage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.setFavoriteList(result.data)
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    }
  }
}
</script>

<style scoped>
  .confirm-delete {
    height: fit-content;
    width: 320px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .body > .text {
    margin: 16px 0px 8px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    line-height: 1.75;
    text-align: center;
  }

  .promptpai-card {
    border: 1px solid rgb(227, 227, 227);
    border-radius: 8px;
    margin-bottom: 32px;
    padding: 4px 0px 8px 0px;
  }

  .body > .button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .body > .button-container > button {
    width: calc((100% - 16px) / 2);
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 0px;
    cursor: pointer;
    font-family: Prompt;
  }

  .body > .button-container > button.outline {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(59, 144, 255);
    color: rgb(59, 144, 255);
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmDelete.vue